import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export function InternalLinks({ links = [], title = "Explore More" }) {
  if (!links.length) return null;
  return (
    <div data-testid="internal-links" className="bg-slate-50 rounded-xl border border-slate-200 p-5">
      <h3 className="font-head font-bold text-slate-900 mb-3">{title}</h3>
      <div className="flex flex-col gap-2">
        {links.map((l, i) => (
          <Link
            key={i}
            to={l.to}
            data-testid={`related-link-${i}`}
            className="group flex items-center justify-between bg-white rounded-lg border border-slate-200 px-4 py-3 hover:border-[#ff4500] transition-colors"
          >
            <span className="text-sm font-semibold text-slate-800 group-hover:text-[#ff4500]">
              {l.label}
            </span>
            <ArrowUpRight size={16} className="text-slate-400 group-hover:text-[#ff4500]" />
          </Link>
        ))}
      </div>
    </div>
  );
}
